import { Fragment, ReactNode } from "react";

import { IPossiblePassenger } from "@ryde/shared";

export const PotentialPassengersTooltip = (
  passengers: IPossiblePassenger[],
): ReactNode => {
  return (
    <div>
      {passengers.map(passenger => (
        <Fragment key={passenger.id}>
          <span>
            {passenger.lastName} {passenger.firstName}
          </span>
          <br />
        </Fragment>
      ))}
    </div>
  );
};
